import { ApiProperty } from '@nestjs/swagger';
import { UserResponseDto } from '../../user/dto/user-response.dto';
import { NewsfeedResponseDto } from '../../newsfeed/dto/newsfeed-response.dto';

export class ChapterResponseDto {
  @ApiProperty({ description: 'Unique identifier of the chapter', example: 1 })
  id: number;

  @ApiProperty({ description: 'Title of the chapter', example: 'Quarterly Updates' })
  title: string;

  @ApiProperty({ description: 'Owner of the chapter', type: () => UserResponseDto })
  user: UserResponseDto;

  @ApiProperty({ description: 'Newsfeeds included in this chapter', type: () => [NewsfeedResponseDto] })
  newsfeeds: NewsfeedResponseDto[];

  @ApiProperty({ description: 'Type of the chapter', examples: ['text', 'audio'] })
  type: string;

  @ApiProperty({ description: 'Creation timestamp', example: '2025-09-03T10:00:00Z' })
  created_at: Date;

  @ApiProperty({ description: 'Last update timestamp', example: '2025-09-03T10:00:00Z' })
  updated_at: Date;
}
